import { getRequiredEnviromentVariable } from "../../sg-core";

interface IEnviromentVariables {
    siteLogo: string;
    kohderekisteri: string,
    apiBaseUrl: string;
    production: boolean;
    publicUrl: string;
    defaultApp: "tyoluvat" | "havainnot" | "auditoinnit";

    applicationMenuHref?: string;
};

export const EnviromentVariables: IEnviromentVariables = {
    siteLogo: process.env.REACT_APP_SITE_LOGO || "/site-logo.png",
    kohderekisteri: getRequiredEnviromentVariable("REACT_APP_KOHDEREKISTERI"),
    apiBaseUrl: getRequiredEnviromentVariable("REACT_APP_API_BASE_URL"),

    production: process.env.NODE_ENV === "production",
    publicUrl: process.env.PUBLIC_URL,
    defaultApp: process.env.REACT_APP_DEFAULT_APP as any || "tyoluvat",
    applicationMenuHref: process.env.REACT_APP_APPLICATION_MENU_HREF || "https://gate.systemsgarden.com/",
};

